const usercenter = () => import('@/page/user-center')
const mycourse = () => import('@/page/user-center/mycourse')
const mymistakes = () => import('@/page/user-center/my-mistakes')
const myclass = () => import('@/page/user-center/myclass')
const myonlineclass = () => import('@/page/user-center/myonlineclass')
const studyarchives = () => import('@/page/user-center/studyarchives')
const studyarchivesYears = () => import('@/page/user-center/studyarchives/years')
const studyarchivesClasses = () => import('@/page/user-center/studyarchives/classes')
const studyarchivesonlineclass = () => import('@/page/user-center/studyarchives/onlineclass')
const qusetionnaire = () => import('@/page/user-center/qusetionnaire')
const teacherGroom = () => import('@/page/user-center/teacher-groom')
const exam = () => import('@/page/user-center/exam')
const leave = () => import('@/page/user-center/my-leave')
export default [
  {
    path: '/usercenter',
    name: 'usercenter',
    component: usercenter,
    children: [
      {
        path: 'mycourse',
        name: 'mycourse',
        component: mycourse
      },
      {
        path: 'questionnaire',
        name: 'questionnaire',
        component: qusetionnaire
      },
      {
        path: 'myclass',
        name: 'myclass',
        component: myclass
      },
      {
        path: 'myonlineclass',
        name: 'myonlineclass',
        component: myonlineclass
      },
      {
        path: 'studyarchives',
        name: 'studyarchives',
        component: studyarchives
      },
      {
        path: 'vote',
        name: 'vote',
        component: qusetionnaire
      },
      {
        path: 'teacherGroom',
        name: 'teacherGroom',
        component: teacherGroom
      },
      {
        path: 'exam',
        name: 'exam',
        component: exam
      },
      {
        path: 'leave',
        name: 'leave',
        component: leave
      },
      {
        path: 'mymistakes',
        name: 'mymistakes',
        component: mymistakes
      }
    ]
  },
  {
    path: '/studyarchivesYears',
    name: 'studyarchivesYears',
    alias: '/usercenter/studyarchives/studyarchivesYears',
    component: studyarchivesYears
  },
  {
    path: '/studyarchivesClasses',
    name: 'studyarchivesClasses',
    alias: '/usercenter/studyarchives/studyarchivesClasses',
    component: studyarchivesClasses
  },
  {
    path: '/studyarchivesonlineclass',
    name: 'studyarchivesonlineclass',
    alias: '/usercenter/studyarchives/studyarchivesonlineclass',
    component: studyarchivesonlineclass
  }
]



// WEBPACK FOOTER //
// ./src/router/user-center/index.js